import * as React from "react";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import { Content } from "../components/content";
import LOGO from "../assets/labour_logo_white.svg";
import PageTitles from "./titles";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { Link } from "react-router-dom";
import { strIsNullOrEmpty } from "../utils/string";
import { ISnackbarContextProps, withSnackbar } from "../components/with-snackbar";
import { AccountServiceClient } from "../model/autogen/AccountController";
import { RoutePaths } from "../route-paths";

function isValidEmail(email: string) {
    return !strIsNullOrEmpty(email.trim());
}

interface IResetPasswordPageComponentProps {

}

type ResetPasswordPageComponentProps = IResetPasswordPageComponentProps & ISnackbarContextProps;

class ResetPasswordPageComponent extends React.Component<ResetPasswordPageComponentProps, any> {
    constructor(props: ResetPasswordPageComponentProps) {
        super(props);
        this.state = {
            email: "",
            isSubmitting: false,
            resetResult: undefined
        };
    }
    private onEmailChanged = (e: any) => {
        this.setState({ email: e.target.value });
    }
    private onSubmit = async (e: any) => {
        const { email } = this.state;
        this.setState({ isSubmitting: true });
        try {
            const result = await AccountServiceClient.reset(email);
            this.setState({ isSubmitting: false, resetResult: result });
        } catch (e) {
            this.setState({ isSubmitting: false, resetResult: undefined });
        }
    }
    render(): JSX.Element {
        const { isSubmitting, email, resetResult } = this.state;
        return <>
            <AppBar position="static" color="primary">
                <Toolbar>
                    <div><img style={{ height: '50px', marginLeft: '-20px' }} className="app-logo-nzl-fern" src={LOGO} /></div>
                </Toolbar>
            </AppBar>
            <Content>
                <h3>{PageTitles.RESET_PASSWORD}</h3>
                {(() => {
                    if (resetResult) {
                        return <>
                            <p>A password reset email has been sent to: <strong>{resetResult.email}</strong></p>
                            <Link to={RoutePaths.SignIn}>Return to Sign-in</Link>
                        </>;
                    } else {
                        if (isSubmitting) {
                            return <LinearProgress />;
                        } else {
                            return <>
                                <TextField fullWidth id="email" label="Email" value={email} onChange={this.onEmailChanged} margin="normal" />
                                <Button variant="contained" color="primary" disabled={!isValidEmail(email)} onClick={this.onSubmit}>Submit</Button>
                            </>;
                        }
                    }
                })()}
            </Content>
        </>;
    }
}

export const ResetPasswordPage = withSnackbar(ResetPasswordPageComponent);


// WEBPACK FOOTER //
// ./src/pages/reset-password-page.tsx